import { Outlet } from "react-router-dom";

const Layout = () => {
  return (
    <main className="flex flex-col bg-slate-50/60 justify-start overflow-auto h-screen w-screen">
      <Outlet />
    </main>
  );
};

export default Layout;
